export const conversionsConfig = {
  rigidply: {
    lamellaLength: { fromUnit: 'millimeters', toUnit: 'feet', unitType: 'length' },
    lamellaWidth: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    lamellaPlannedWidth: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    lamellaThickness: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    lamellaPlannedThickness: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    plannedLamellaWidth: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    plannedLamellaThickness: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    averageLength: { fromUnit: 'millimeters', toUnit: 'feet', unitType: 'length' }
  },
  smartlam: {
    lamellaLength: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    lamellaWidth: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    lamellaPlannedWidth: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    plannedLamellaWidth: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    lamellaThickness: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    lamellaPlannedThickness: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    plannedLamellaThickness: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' },
    averageLength: { fromUnit: 'millimeters', toUnit: 'inches', unitType: 'length' }
  }
};
